<div style="min-height: 100vh; background: white">
  <h1>Docs</h1>

  <pc-button [wide]="true" [text]="'Test Button'"></pc-button>
</div>
